import { DEFAULT_TASK_DURATION_IN_MINUTES, DEFAULT_TASK_DURATION_FOR_MEETING_IN_MINUTES, MINUTES_TO_MILLISECONDS } from "../../helpers/constants";

export const getDefaultTaskPeriodStr = (beginDate = new Date(), taskWay=null) => {
    console.log('taskWay', taskWay)
    const defaultTaskDurrationTime = taskWay && taskWay === "MEETING" ? DEFAULT_TASK_DURATION_FOR_MEETING_IN_MINUTES : DEFAULT_TASK_DURATION_IN_MINUTES

    const endDate = new Date(
        beginDate.getTime() + defaultTaskDurrationTime * MINUTES_TO_MILLISECONDS,
    );
    const start = `${beginDate.getHours().toString().padStart(2, "0")}:${beginDate.getMinutes().toString().padStart(2, "0")}`;
    const end = `${endDate.getHours().toString().padStart(2, "0")}:${endDate.getMinutes().toString().padStart(2, "0")}`;
    return { start, end };
};
